import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../../assets/styles/media';
import THEME from '../../../assets/styles/config';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const InputBox = styled.input`
  border-bottom: 2px solid ${THEME.colors.primaryFontColor};
  margin: 20px 0;
  padding: 10px 0;
  font-size: 18px;
  width: 100%;
  transition: border-bottom 300ms ease-in-out;

  &:focus {
    border-bottom: 2px solid ${THEME.colors.primaryColor};
  }
`;

export const PasswordDiv = styled.div`
  position: relative;

  ${Media.Below.tablet`
    font-size: 20x;
  `}
`;

export const SignIn = styled.h2`
  color: ${THEME.colors.primaryFontColor};

  ${Media.Below.tablet`
    font-size: 20x;
  `}
`;

export const ShowButton = styled.button`
  display: flex;
  align-items: center;
  position: absolute;
  left: 82%;
  top: 37%;
  background-color: transparent;
  font-size: 14px;

  &:focus {
    outline: 0px;
  }

  ${Media.Below.tablet`
    left: 76%;
  `}

  ${Media.Below.mobileLarge`
    left: 78%;
  `}

  > span {
    color: ${THEME.colors.primaryFontColor};
    margin-left: 5px;
  }
`;

export const SubmitButton = styled.input`
  margin-top: 10vh;
  padding: 20px 0;
  background: ${THEME.colors.primaryColor};
  color: white;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 1.5px;
  cursor: pointer;

  ${Media.Below.tablet`
    margin-top: 35px;
    padding: 12px 0;
    font-size: 12px;
  `}
  
  &:disabled {
    opacity: 0.3;
  }
`;
